import {HostBinding, Component, Injector, OnInit } from "@angular/core";
import {  BaseComponent } from "../../base.component";

@Component({
    selector : 'custom-title-3',
    host: { '[class]': 'myCustomClass' },
    template: `
    <h3 style="{{control.attributes.style }}">{{ control.attributes.content }}</h3>
    `,
    styleUrls: ["./custom-title-3.component.scss"]
})

export class CustomTitle3Component extends BaseComponent implements OnInit {
    constructor(injector : Injector) {
        super(injector);
      }
      ngOnInit() {
      }
}

